<template>
  <div></div>
</template>

<script>
export default {
  data() {
    return {
      client_id: "",
      redirect_uri: "",
      response_type: "",
      scope: "",
      state: "",
    };
  },
  mounted() {
    console.log("携带的参数", this.$route.query);
    const loading = this.$loading({
      lock: true,
      text: "认证中",
      spinner: "el-icon-loading",
      // background: "rgba(0, 0, 0, 0.7)",
    });
    if (this.cookies.getCookie("token")) {
      console.log("有token");
      let client_id = this.$route.query.data
        ? this.$route.query.data.client_id
        : this.$route.query.client_id;
      let redirect_uri = encodeURIComponent(
        this.$route.query.data
          ? this.$route.query.data.redirect_uri
          : this.$route.query.redirect_uri
      );
      let response_type = this.$route.query.data
        ? this.$route.query.data.response_type
        : this.$route.query.response_type;
      let scope = this.$route.query.data
        ? this.$route.query.data.scope
        : this.$route.query.scope;
      let state = encodeURIComponent(
        this.$route.query.data
          ? this.$route.query.data.state
          : this.$route.query.state
      );
      let token = this.cookies.getCookie("token");

      this.getUrlKeys();

      window.open(
        env.API_HOST +
          `/oauth/authorize?response_type=${response_type}&scope=${scope}&client_id=${client_id}&state=${state}&redirect_uri=${redirect_uri}&x-auth-token=${token}`,
        "_self"
      );
    } else {
      this.item = this.$route.query;
      console.log("无token");
      console.log("携带");
      loading.close();
      this.$router.push({
        name: "login",
        query: { authentication: false, data: this.item },
      });
    }
  },
  methods: {
    getUrlKey(name) {
      return name.split("state=");
    },
    getUrlKeys() {
      var url = window.location.href; //获取当前url
      console.log(url);
      var dz_url = url.split("#")[0]; //获取#/之前的字符串
      var cs = dz_url.split("?")[1]; //获取?之后的参数字符串
      var cs_arr = cs.split("&"); //参数字符串分割为数组
      var cs = {};

      for (var i = 0; i < cs_arr.length; i++) {
        //遍历数组，拿到json对象
        cs[cs_arr[i].split("=")[0]] = cs_arr[i].split("=")[1];
      }
      this.state = cs.state;
    },
  },
};
</script>

<style scoped></style>
